import { BaseSignalr } from '@portkey/socket';
import { DefaultRampListenList } from '../constants/index.js';
export class RampSignalr extends BaseSignalr {
    constructor(options) {
        const { listenList = DefaultRampListenList } = options || {};
        super({ listenList });
    }
    requestRampOrderStatus(clientId, orderId) {
        return this.invoke('RequestRampOrderStatus', {
            targetClientId: clientId,
            orderId: orderId,
        });
    }
    onRampOrderChanged(callback) {
        return this.listen('onRampOrderChanged', (data) => {
            callback(data.body);
        });
    }
}
